import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bahrainiDinar'
})
export class BahrainiDinarPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    var currentLang = localStorage.getItem('lang');
    if (currentLang == "ar") {
        return value.toString()+'د.ب ';
    } else {
      return value.toString()+' BHD';
    }  }

}
